import { ShieldCheck, ArrowRight } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_sales-velocity-43/artifacts/nh1fjaiq_Copy%20of%20ZEESHAN%20TECHBORN%20CARD-2.png";

export default function Login({ error }) {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div
      data-testid="login-screen"
      className="min-h-screen flex bg-slate-950 text-white font-body"
    >
      {/* Left brand panel */}
      <div className="hidden lg:flex w-[46%] flex-col justify-between p-14 relative overflow-hidden bg-slate-900">
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, #3b82f6 0, transparent 40%), radial-gradient(circle at 80% 60%, #ef4444 0, transparent 45%)",
          }}
        />
        <div className="relative flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl overflow-hidden bg-white ring-1 ring-white/20 flex items-center justify-center">
            <img src={LOGO_URL} alt="Techborn Ventures" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="font-heading text-lg font-bold tracking-tight">Techborn Ventures</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-red-400 font-bold">
              Private Limited
            </div>
          </div>
        </div>
        <div className="relative">
          <h1 className="font-heading text-4xl xl:text-5xl font-bold leading-tight">
            The command center for your <span className="text-blue-400">sales pipeline</span>.
          </h1>
          <p className="mt-5 text-slate-400 text-base max-w-md">
            Leads, orders, commissions and reports — one shared workspace for the whole Techborn team.
          </p>
        </div>
        <div className="relative flex items-center gap-2 text-xs text-slate-500">
          <ShieldCheck size={15} className="text-emerald-400" />
          Secured with company Google Sign-in
        </div>
      </div>

      {/* Right sign-in panel */}
      <div className="flex-1 flex items-center justify-center p-6 bg-white text-slate-900">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <div className="w-11 h-11 rounded-lg overflow-hidden bg-white ring-1 ring-slate-200 flex items-center justify-center">
              <img src={LOGO_URL} alt="Techborn Ventures" className="w-full h-full object-contain" />
            </div>
            <div className="font-heading text-[15px] font-bold tracking-tight">Techborn Ventures</div>
          </div>

          <h2 className="font-heading text-2xl font-bold">Sign in to Techborn Data Center</h2>
          <p className="mt-2 text-sm text-slate-500">
            Use your <span className="font-semibold text-slate-700">@techbornventures.com</span> Google
            account to continue.
          </p>

          {error && (
            <div
              data-testid="login-error"
              className="mt-6 rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700"
            >
              {error}
            </div>
          )}

          <button
            data-testid="google-signin-btn"
            onClick={signIn}
            className="group mt-7 w-full h-12 rounded-xl bg-slate-900 text-white font-semibold flex items-center justify-center gap-3 hover:bg-slate-800"
            style={{ transition: "background-color 180ms ease" }}
          >
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt=""
              className="w-5 h-5 bg-white rounded-full p-0.5"
            />
            Continue with Google
            <ArrowRight
              size={17}
              className="opacity-70 group-hover:translate-x-0.5"
              style={{ transition: "transform 180ms ease" }}
            />
          </button>

          <p className="mt-6 text-xs text-slate-400 leading-relaxed">
            Access is restricted to Techborn Ventures employees. If you see an access error, contact your
            administrator (ahmar@techbornventures.com).
          </p>
        </div>
      </div>
    </div>
  );
}
